import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { getDb } from "../../../util/Constants";
import { collection, addDoc } from "firebase/firestore";
import Swal from "sweetalert2";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import "../../../assets/css/questionnaire.css";
import { imageMap } from "../../../util/Constants";
export default function AddMiniGame8Modal({ isOpen, toggle, onQuestionAdded }) {
  const [sequence, setSequence] = useState([]);
  const [loading, setLoading] = useState(false);
  const resetFields = () => setSequence([]);
  const handleAddToSequence = (key) => setSequence((prev) => [...prev, key]);
  const handleRemoveFromSequence = (idx) =>
    setSequence((prev) => prev.filter((_, i) => i !== idx));

  const handleSubmit = async () => {
    if (!sequence.length) {
      Swal.fire(
        "Error",
        "Please add at least one image to the sequence.",
        "error"
      );
      return;
    }
    setLoading(true);
    try {
      await addDoc(collection(getDb(), "questions"), {
        miniGame: "Mini 8",
        sequence,
      });
      Swal.fire("Success", "Question added!", "success");
      resetFields();
      toggle();
      if (onQuestionAdded) onQuestionAdded();
    } catch (error) {
      Swal.fire("Error", "Failed to add question.", "error");
    }
    setLoading(false);
  };
  const onDragEnd = (result) => {
    if (!result.destination) return;
    const reordered = Array.from(sequence);
    const [removed] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, removed);
    setSequence(reordered);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
      <ModalHeader toggle={toggle}>Add MiniGame 8 Question</ModalHeader>
      <ModalBody>
        <div style={{ marginBottom: 16, fontWeight: 500 }}>
          Select Images (click Add):
        </div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 18,
            marginBottom: 24,
          }}
        >
          {Object.keys(imageMap).map((key) => (
            <div key={key} style={{ textAlign: "center" }}>
              <img
                src={imageMap[key]?.default}
                alt={key}
                width={60}
                height={60}
                style={{ border: "1px solid #eee", borderRadius: 8 }}
              />
              <div style={{ fontSize: 12, margin: "4px 0" }}>{key}</div>
              <Button
                color="primary"
                size="sm"
                onClick={() => handleAddToSequence(key)}
                style={{ marginTop: 2 }}
              >
                Add
              </Button>
            </div>
          ))}
        </div>
        <div style={{ fontWeight: 500, marginBottom: 8 }}>
          Current Sequence (drag to reorder):
        </div>
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="miniGame8-sequence" direction="horizontal">
            {(provided) => (
              <div
                ref={provided.innerRef}
                {...provided.droppableProps}
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 12,
                  minHeight: 70,
                }}
              >
                {sequence.length === 0 && (
                  <span style={{ color: "#888" }}>No images added yet.</span>
                )}
                {sequence.map((key, idx) => (
                  <Draggable
                    key={key + idx}
                    draggableId={key + idx}
                    index={idx}
                  >
                    {(provided2, snapshot) => (
                      <div
                        ref={provided2.innerRef}
                        {...provided2.draggableProps}
                        {...provided2.dragHandleProps}
                        className={
                          "draggable-image-mini8-add" +
                          (snapshot.isDragging ? " dragging" : "")
                        }
                        style={provided2.draggableProps.style}
                      >
                        <img
                          src={imageMap[key]?.default}
                          alt={key}
                          width={50}
                          height={50}
                          className="draggable-image-mini8-img"
                        />
                        <div className="draggable-image-mini8-key">{key}</div>
                        <Button
                          color="danger"
                          size="sm"
                          className="draggable-image-mini8-remove-btn"
                          onClick={() => handleRemoveFromSequence(idx)}
                        >
                          Remove
                        </Button>
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSubmit} disabled={loading}>
          {loading ? "Adding..." : "Add"}
        </Button>
        <Button color="secondary" onClick={toggle} disabled={loading}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}
